/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import Icons from './../../assets/icons';
import { hexToRgb } from './../../ui/styled';

// import { getScaledValue } from 'renative';

import { getScaledValue } from '../../ui/styled';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export const SideMoreContainer = styled.View.attrs({})`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: ${getScaledValue(240)}px;
  background-color: rgba(36, 36, 36, 0.9);
  padding: ${getScaledValue(24)}px;
`;

export const SideMoreClose = withFocusable()(styled.TouchableOpacity.attrs({})`
  width: ${getScaledValue(18)}px;
  height: ${getScaledValue(18)}px;
  border-radius: ${getScaledValue(9)}px;
  background-color: rgba(255, 255, 255, 0.14);
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            background-color: ${props.theme.primary};
        `
      : ``}
  align-items: center;
  justify-content: center;
  align-self: flex-end;
`);

export const SideMoreCloseIcon = styled(Icons).attrs({
  icon: 'close',
  width: getScaledValue(6),
  height: getScaledValue(6),
  stroke: '#ffffff',
})``;

export const SideMoreHeader = styled.View.attrs({})`
  margin-bottom: ${getScaledValue(25)}px;
`;
export const SideMoreHeaderTitle = styled.Text.attrs({})`
  font-family: PTSans-Regular;
  font-size: ${getScaledValue(24)}px;
  color: #ffffff;
`;
export const SideMoreHeaderText = styled.Text.attrs({})`
  font-family: PTSans-Regular;
  font-size: ${getScaledValue(12)}px;
  color: #ffffff;
`;

export const SideMoreItem = withFocusable()(styled.TouchableOpacity.attrs(
  (props: { focused?: boolean; theme: { primary: string } }) => ({}),
)`
  padding: ${getScaledValue(10)}px;
  border-radius: ${getScaledValue(3)}px;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            background-color: ${props.theme.primary};
            border-width: ${getScaledValue(2)}px;
            border-color: #ffffff;
            box-shadow: 0px 0px 14px rgba(${hexToRgb(props.theme.primary)}, .9);
        `
      : `
            background-color: #222222;
        `}
  margin-bottom: ${getScaledValue(12)}px;
`);

export const SideMoreItemText = styled.Text.attrs({})`
  font-family: PTSans-Regular;
  font-size: ${getScaledValue(12)}px;
  color: #ffffff;
`;
